import Cookies from "js-cookie";
import { create } from "zustand";
import { baseURL, setToken } from "../../../config/index";
import  secureLocalStorage  from  "react-secure-storage";
import {
  userLogin,
  forgotPasswordRequest,
  trayaGoogleLogin,
  getUserDetails,
  resetPasswordApi,
  loginOtpApi,
  getMyCallProviders
} from "../api_layer/api";
import { TOAST_MESSAGE_CSS, validateEmail } from "modules/utilities/utility";
import { act } from "react-dom/test-utils";
import { DIRECT_LOGIN_EMAIL } from "modules/utilities/utility_2";
import _ from 'lodash';

export const userLoginStore = create((set) => ({
  res: "",
  isLoading: false,
  error: null,
  userData: null,
  fetchLoginData: async (
    loginEmail,
    password,
    setToaster,
    setUserDetails,
    navigate,
    validateUrl,
    loginWithOtp,
    toast
  ) => {
    try {
      const [username, domain] = loginEmail.split("@");
      const [actualDomain, tld] = domain.split(".");
      if (validateUrl.includes(actualDomain) || domain.includes("maxicus") || /(localhost|dev)/.test(window.location.href)) {
        set({ isLoading: true });
        const response = await userLogin(loginEmail, password);
        // if (DIRECT_LOGIN_EMAIL.includes(loginEmail)) {
          const otp = response.data.slice(-6);
          const payload = {
            email: loginEmail,
            otp: otp,
          };
          await loginWithOtp(payload, toast, setUserDetails);
        // } else {
        //   localStorage.setItem("otpEmail", loginEmail);
        //   navigate(`/loginWithOtp`);
        // }
        set({isLoading:false})
      }
    } catch (error) {
      set({
        error: error.message,
        isLoading: false,
      });
      secureLocalStorage.removeItem("otpEmail");
      secureLocalStorage.clear();
      setToaster("Login", "Failed to log in", "danger");
    }
  },
  forgotPassword: async (email, setToaster) => {
    try {
      const response = await forgotPasswordRequest(email);
      setToaster(
        "Forgot password",
        "Please check your mail for resetting password",
        "success"
      );
      set({ res: response.status });
    } catch (error) {
      setToaster(
        "Forgot password",
        <p className="mb-0 fw-bold">{error?.response?.data?.message}</p>,
        "danger"
      );
      set({ res: error?.response?.status });
    }
  },
}));

export const useGoogleLogin = create(() => ({
  googleLogin: async (googleData, setToaster, setUserDetails) => {
    try {
      const response = await trayaGoogleLogin(googleData.tokenId);
      setToaster("login", "Login Successfully", "success");
      Cookies.set("token", response.data.token);
      setToken(response.data.token);
      setUserDetails();
    } catch (error) {
      setToaster("Login", "Failed to Login", "danger");
    }
  },
  resetPassword: async (id, payload, toast, navigate) => {
    try {
      await resetPasswordApi(id, payload);
      toast.success("Sent on Email, PLease check", TOAST_MESSAGE_CSS);
      navigate("/login");
    } catch (error) {
      toast.error(
        "Failed to send email, please check email",
        TOAST_MESSAGE_CSS
      );
    }
  },
  loginWithOtp: async (payload, toast, setUserDetails) => {
    try {
      const response = await loginOtpApi(payload);
      Cookies.set("token", response.data.token);
      setToken(response.data.token);
      toast.success("You have logged in successfully", TOAST_MESSAGE_CSS);
      setUserDetails();
    } catch (error) {
      toast.error("Login Failed", TOAST_MESSAGE_CSS);
      secureLocalStorage.removeItem('otpEmail');
      secureLocalStorage.clear();
    }
  },
}));

export const useSetUserDetails = create((set) => ({
  userResponse: [],
  myCallProviders: [],
  setUserDetails: async () => {
    try {
      const userData = await getUserDetails();
      const callProviders = await getMyCallProviders();
      const {
        id,
        email,
        first_name,
        house,
        team,
        desgination,
        shift,
        alternate_email,
        level,
        is_consult_doctor,
        is_supervisor,
        voitekk_id,
        clinic_id,
        clinic_emp_id,
        is_first_login,
        is_not_clocked_out_yesterday,
        roles: [
          {
            role: { id: roleID },
          },
        ],
      } = userData.data;
      secureLocalStorage.clear();
      secureLocalStorage.setItem("id", id);
      secureLocalStorage.setItem("email", email);
      secureLocalStorage.setItem("first_name", first_name);
      secureLocalStorage.setItem("alternate_email", alternate_email);
      secureLocalStorage.setItem("level", level);
      secureLocalStorage.setItem("is_supervisor", is_supervisor);
      secureLocalStorage.setItem("role", roleID);
      secureLocalStorage.setItem("obj", JSON.stringify(userData.data));
      secureLocalStorage.setItem("is_consult_doctor", Boolean(is_consult_doctor));
      secureLocalStorage.setItem("voitekk_id", voitekk_id);
      secureLocalStorage.setItem("popUp_Count", 0);
      secureLocalStorage.setItem("clinic_id", clinic_id);
      secureLocalStorage.setItem("clinic_emp_id", clinic_emp_id);
      secureLocalStorage.setItem("shift", shift);
      secureLocalStorage.setItem("is_first_login", is_first_login);
      secureLocalStorage.setItem("is_not_clocked_out_yesterday", is_not_clocked_out_yesterday);
      secureLocalStorage.setItem("house", house);
      secureLocalStorage.setItem("team", team);
      secureLocalStorage.setItem("designation", desgination);

        //Getting the user call provider
        if (callProviders) {
          const providers = _.get(callProviders, ["data", "data"]);
  
          if (!_.isEmpty(providers)) {
            secureLocalStorage.setItem(
              "call_providers",
              JSON.stringify(providers)
            );
            set({ myCallProviders: providers });
          }
        }    
      window.location.href = "/";
    } catch (error) {
      console.error("Failed to fetch user details:", error);
    }
  },
  getUserData: async () => {
    try {
      const userData = await getUserDetails();
      set({ userResponse: userData.data, ticketLoading: false });
    } catch (error) {
      console.error("Failed to fetch user details:", error);
    }
  }
}));
